<template>
  <div class="container" :class="{ 'u-pop': isPopup }">
    <div class="list-wrap">
      <p class="xz" @click="unshiftPersonWithoutChecked">
        <i class="btn_add iconfont icon-jia"></i>
        <span>新增常用游客</span>
      </p>
      <!-- v-if="numNeedMore > 0" -->
      <!-- <div class="num_need_more">
        还需添加
        <span>{{ numNeedMore }}</span>
        位游客
      </div> -->
      <ul v-if="list && list.length > 0">
        <li v-for="item in list" :key="item.tpid">
          <person-item
            :item="item"
            @modify="modify"
            @removed="removed"
            @toggleCheck="toggleCheck"
          ></person-item>
        </li>
      </ul>
      <empty v-else :text="emptyTips" top="0rem"></empty>
    </div>

    <div class="footer">
      <a
        href="#"
        class="btn"
        :class="{ activated: numNeedMore === 0 }"
        @click.prevent="submitList"
      >
        <span v-if="numNeedMore > 0">还需添加{{ numNeedMore }}位游客</span>
        <span v-else>完成</span>
      </a>
    </div>
  </div>
</template>

<script>
import findIndex from 'lodash/findIndex'
import { cloneDeep } from 'lodash'
import top from 'components/common/top'
import personItem from './item'
import http from '@/plugins/http'
import empty from '@/components/common/empty'

export default {
  components: {
    top,
    personItem,
    empty
  },
  data() {
    return {
      skuId: '',
      title: '选择游客',
      list: [],
      isNumEnough: false,
      // isSaveEnabled: false,
      emptyTips: '您还没有游客信息<br/>请点击上方“新增常用游客”进行添加'
    }
  },
  props: {
    isPopup: {
      type: Boolean,
      default: false
    },
    allList: {
      type: Array,
      default: () => []
    },
    tpidsIn: {
      type: Array,
      default: () => []
    },
    numIn: {
      type: Number,
      default: 0
    }
  },
  computed: {
    listChecked() {
      return this.list.filter(item => item.isChecked)
    },
    tpids() {
      const tpidsUrl =
        this.$route.query.checkedIds ||
        this.$route.query.tpid ||
        this.$route.query.tpids ||
        ''
      const tpidsUrlArr = tpidsUrl.split(',').map(item => item * 1)
      return this.tpidsIn.length ? this.tpidsIn : tpidsUrlArr
    },
    requiredNum() {
      return this.numIn
    },
    numNeedMore() {
      return this.requiredNum - this.listChecked.length
    },
    isSaveEnabled() {
      // 如果不验证游客人数，就开启按钮
      return (
        this.requiredNum === 0 || this.listChecked.length === this.requiredNum
      )
    },
    isAddMrg() {
      return !this.isPopup && !this.$$isCZJApp()
    }
  },
  watch: {
    allList: {
      deep: true,
      handler(newVal, oldVal) {
        let selects = []
        if (this.list) {
          selects = this.list.filter(x => x.isChecked).map(x => x.tpid)
        }
        console.log(selects)
        this.list = cloneDeep(newVal).map(x => {
          let isChecked = false
          if (selects.indexOf(x.tpid) > -1) {
            isChecked = true
          }
          return {
            ...x,
            isChecked
          }
        })
        console.log('after watch allList')
      }
    }
  },
  created() {},
  async mounted() {
    this.$$loading(false)
    this.skuId = this.$route.query.skuId || ''
    console.log('oooooo')
    this.list = cloneDeep(this.allList)
  },
  methods: {
    unshiftPersonWithoutChecked() {
      this.$emit('unshiftPerson')
    },
    toggleCheck(item) {
      if (this.requiredNum === 1 && !item.isChecked) {
        item.isChecked = true
        this.list.forEach(otherItem => {
          if (otherItem.tpid != item.tpid) {
            otherItem.isChecked = false
          }
        })
        return
      }

      let diff = this.requiredNum - this.listChecked.length
      if (diff > 0 || item.isChecked) {
        item.isChecked = !item.isChecked
      } else {
        this.$$toast({
          message: `您已选满${this.requiredNum}位.请先点消一位,再来点选`,
          className: 'mint-or-top'
        })
      }
    },
    submitList() {
      if (!this.isSaveEnabled) {
        this.$$toast({
          message: `请选择 ${this.requiredNum} 位游客`,
          className: 'mint-or-top'
        })
        return 1
      }

      if (this.isPopup) {
        // 执行一次浅拷贝，以防止引用影响
        this.$emit('usePersonList', this.list, [].concat(this.listChecked))
        this.allList.forEach(item => {
          item.isChecked = true
        })
      } else {
        this.$router.back()
      }
    },
    modify(item) {
      this.$emit('modify', item)
    },
    removed(tpid) {
      let index = -1
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].tpid == tpid) {
          index = i
          break
        }
      }
      if (index > -1) {
        this.list.splice(index, 1)
        this.$emit('removed', tpid)
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.container {
  background: #fff;
  position: relative;
  overflow-y: visible;
  height: 100%;

  &.u-pop {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    overflow-scrolling: touch;
  }
}

.btn_add {
  font-size: rem(32px);
}

.list-wrap {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-bottom: rem(150px);
  overflow-x: hidden;
  overflow-y: auto;
  overflow-scrolling: touch;

  li {
    overflow: hidden;
    margin: rem(22px) rem(16px);
    position: relative;
    border-bottom: 1px solid #f0f0f0;
  }

  .num_need_more {
    height: rem(48px);
    font-size: rem(30px);
    color: #262626;
    line-height: rem(48px);
    margin: rem(48px) 0 rem(20px) rem(48px);

    span {
      height: rem(48px);
      font-size: rem(30px);
      color: #ff5900;
      line-height: rem(48px);
    }
  }
}

.footer {
  z-index: 99;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  // transform: translate3d(0, 0, 1px);
  background-color: #fff;

  .btn {
    color: #fff;
    font-size: rem(32px);
    text-align: center;
    display: block;
    line-height: rem(80px);
    height: rem(80px);
    background-image: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
    border-radius: rem(40px);
    margin: rem(10px) rem(24px) rem(68px) rem(24px);
    opacity: 0.5;

    i {
      margin-right: rem(10px);
    }

    &.activated {
      background-image: linear-gradient(to right, #ff7d46, #ff4b4b);
      opacity: 1;
    }
  }
}

.btn-top {
  font-size: rem(28px);
  line-height: 2em;
  height: 2em;
  padding-left: 0.8em;
  float: right;
  color: #cccccc;

  &.activated {
    color: #121212;
  }
}

.xz {
  i {
    margin-right: rem(12px);
  }

  margin: rem(48px) rem(48px);
  background: #fff;
  text-align: center;
  height: rem(80px);
  line-height: rem(80px);
  font-size: rem(32px);
  color: #fd5e04;
  border: rem(1px) solid rgba(255, 89, 0, 1);
  border-radius: rem(40px);
}
</style>
<style lang="scss" rel="stylesheet/scss">
// 由于Toast的z-index小于Popup，故需要重写
.mint-or-top {
  z-index: 9999;
}
</style>
